import Foundation from 'foundation-sites';

export default class {
  constructor($formEl, $modalEl) {
    Foundation.Abide.defaults.validators['force_number_range_rule'] = this.forceNumberRangeValidator;
    Foundation.Abide.defaults.validators['force_money_range_rule'] = this.forceMoneyRangeValidator;
    Foundation.Abide.defaults.validators['force_rate_rule'] = this.forceRateValidator;
    new Foundation.Abide($formEl);
    new Foundation.Reveal($modalEl);  
  }
  forceNumberRangeValidator ($el, required, parent) {
      const from = parseInt($el[0].getAttribute('data-min'), 10),
          to = parseInt($el[0].getAttribute('data-max'), 10),
          val = parseInt($el.val());
      if (val < from) $el.val(from);
      if (val > to) $el.val(to);
      return true
  }
  forceMoneyRangeValidator ($el, required, parent) {  // Must be applied to a text field for reverseFormatMoney to work
      const from = parseInt($el[0].getAttribute('data-min'), 10),
          to = parseInt($el[0].getAttribute('data-max'), 10),
          val = parseInt($el.val().reverseFormatMoney());       
          if (val < from) $el.val(from)
          if (val > to) $el.val(to)
       if(val) return true
  }
  forceRateValidator ($el, required, parent) {
      const from = parseFloat($el[0].getAttribute('data-min')),
          to = parseFloat($el[0].getAttribute('data-max')),
          val = parseFloat($el.val().replace(/[^0-9\.]/g, ''));
      if (val < from) $el.val(from);
      if (val > to) $el.val(to);
  }
}